/**
 * HQ 공지사항 관리 서비스. 본부가 점주에게 보내는 공지 CRUD.
 */
import hqApi from './hqApiClient';

export interface HqNotice {
  id: string;
  franchise_brand_id: string | null;
  title: string;
  body: string;
  version: string | null;
  is_active: boolean;
  show_popup: boolean;
  show_dashboard: boolean;
  is_important?: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface HqNoticeInput {
  title: string;
  body: string;
  version?: string | null;
  is_active?: boolean;
  show_popup?: boolean;
  show_dashboard?: boolean;
  is_important?: boolean;
}

export const hqNoticeService = {
  async list(): Promise<HqNotice[]> {
    const { data } = await hqApi.get<HqNotice[]>('/api/v1/hq/notices');
    return data;
  },
  async create(payload: HqNoticeInput): Promise<HqNotice> {
    const { data } = await hqApi.post<HqNotice>('/api/v1/hq/notices', payload);
    return data;
  },
  async update(id: string, payload: Partial<HqNoticeInput>): Promise<HqNotice> {
    const { data } = await hqApi.put<HqNotice>(`/api/v1/hq/notices/${id}`, payload);
    return data;
  },
  async remove(id: string): Promise<void> {
    await hqApi.delete(`/api/v1/hq/notices/${id}`);
  },
};
